<div class="field"
     [ngClass]="{'disabled': isDisabled, 'error': hasErrors()}"
     [hidden]="isHidden"
>
  <label *ngIf="controlOptions.label">{{controlOptions.label}}</label>
  <input
         [name]="controlId"
         [tabIndex]="disabledTabIndex()"
         [formControl]="formControlInstance"
         type="file"
  >
  <div *ngIf="hasErrors()" class="ui red pointing label">
    {{errorMessage}}
  </div>
</div>


